var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('div',{staticClass:"tcdc-ebook-card",staticStyle:{"cursor":"pointer"},on:{"click":_vm.eventClick}},[_c('span',{staticClass:"tcdc-ebook-card-inside"},[_c('img',{staticClass:"tcdc-ebook-image",attrs:{"src":_vm.image,"loading":"lazy"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }